import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import get from 'lodash/get';
import { selectFeatureFlags } from '../../selectors/ContextSelector';

export class Loading extends Component {
    static propTypes = {
        isLoading: PropTypes.bool,
        featureFlags: PropTypes.object,
    };

    static defaultProps = {
        isLoading: false,
        featureFlags: {},
    };

    shouldComponentUpdate(nextProps) {
        return this.props.isLoading !== nextProps.isLoading;
    }

    render() {
        const { featureFlags, isLoading } = this.props;
        return (get(featureFlags, 'enableSKUAvailabilityLogic', true) &&
            isLoading &&
            !isLoading.customLoader) ||
            (!get(featureFlags, 'enableSKUAvailabilityLogic', true) && isLoading) ? (
            <Loader keepOverlay automationId="test-automation-loader-1" />
        ) : null;
    }
}

const mapStateToProps = (state) => ({
    isLoading: state.isLoading,
    featureFlags: selectFeatureFlags(state),
});

// if isLoading is passed in explicitly, use it
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    isLoading: get(ownProps, 'isLoading', stateProps.isLoading),
});

export default connect(mapStateToProps, null, mergeProps)(Loading);
